import { Injectable, Component } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Card } from './card.model';
import { CardService } from './card.service';
import { StudentService } from '../student/student.service';
import { CARD_UNLIMITED_BOOKINGS_NUMBER } from '../../shared';

@Injectable()
export class CardPopupService {
    private isOpen = false;
    private defaultUnlimitedClasses = false;
    constructor(
        private modalService: NgbModal,
        private router: Router,
        private cardService: CardService,
        private studentService: StudentService
    ) { }

    open(component: Component, id?: number | any  | any, studentId?: number): NgbModalRef {
        if (this.isOpen) {
            return;
        }
        this.isOpen = true;

        if (id) {
            this.cardService.find(id).subscribe(card => {
                card.unlimitedClasses = card.maxAssistancesNum >= CARD_UNLIMITED_BOOKINGS_NUMBER;
                this.cardModalRef(component, card);
            });
        } else {
            let card: Card = new Card();
            let today: Date = new Date();
            card.validSince = {
                    year: today.getFullYear(),
                    month: today.getMonth() + 1,
                    day: today.getDate()
                };
            card.unlimitedClasses = this.defaultUnlimitedClasses;

            if (studentId) {
                // We are creating a card for a specific student
                this.studentService.find(studentId).subscribe(student => {
                    card.student = student;
                    return this.cardModalRef(component, card);
                });
            } else {
                // we are creating a card without student
                setTimeout(() => {
                    // the setTimeout is needed to avoid ExpressionChangedAfterItHasBeenCheckedError error in dev mode
                    return this.cardModalRef(component, card);
                });
            }

        }
    }

    cardModalRef(component: Component, card: Card): NgbModalRef {
        let modalRef = this.modalService.open(component, { size: 'lg', backdrop: 'static' });
        modalRef.componentInstance.card = card;
        modalRef.result.then(result => {
            this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            this.isOpen = false;
        }, (reason) => {
            this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            this.isOpen = false;
        });
        return modalRef;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/card/card-popup.service.ts